export const SELECT_LIMIT = 30

export const MESSAGES = {
  GROUP_CHANGE:
    'You are switching to a different ticket type. Are you sure you want to discard selected seats?',
  ALREADY_RESERVED: 'Selected seat is not available',
  LIMIT_EXCEEDED: `You can buy ${SELECT_LIMIT} tickets at a time`,
  SESSION_EXPIRED: 'Session expired',
  UNEXPECTED_ERROR: 'Unexpected error'
}

export const COLORS = {
  BACKGROUND: '#ffffff',
  AVAILABLE: '#80c87f',
  PREDEFINED: '#009999',
  BOOKED: '#e26da0',
  RESERVED: '#7c8fd2',
  RESERVED_BY_ME: '#f5d158',
  BLOCKED: '#808080',
  HOLD: '#b1b1b1',
  STAGE: '#f1f3f7',
  STAGE_BORDER: '#c8d6ec',
  SELECTED_BLOCK_BORDER: `#696969`,
  HIGHLIGHT: `#f5d158`,
  DARK_GREY: '#bbbbbb',
  SOLD: '#ff0000',
  'ON HOLD': '#b1b1b1'
}

export const TIER_COLORS = [
  '#4a2ac0',
  '#ff5cb7',
  '#d86500',
  '#33c379',
  '#9d0f3c',
  '#005985',
  '#abcb00',
  '#3b2f2f',
  '#264653',
  '#008000',
  '#2a9d8f',
  '#e9c46a',
  '#e76f51',
  '#9b5de5',
  '#0063e4',
  '#540d6e',
  '#dd3b3b',
  '#83e377',
  '#2d3047',
  '#8da2dd',
  '#0f39f8',
  '#8cb369',
  '#fdf148',
  '#4fd9b6',
  '#b92755',
  '#e1f400',
  '#968e85',
  '#fc296d',
  '#2667c4',
  '#5c0029',
  '#857c8d',
  '#3e4d06',
  '#153131',
  '#af5b74',
  '#616b77',
  '#02654b',
  '#38b6fa',
  '#ee7808',
  '#eca0ba',
  '#90251b',
  '#aaf683',
  '#8e7dbe',
  '#01295f',
  '#ab87ff',
  '#986b2a',
  '#789171',
  '#61304b',
  '#94f686',
  '#f9b3c7',
  '#f0d193'
]

export const SEAT_STATUSES = {
  AVAILABLE: 'A',
  RESERVED: 'R',
  RESERVED_BY_ME: 'OR',
  BOOKED: 'B',
  BLOCKED: 'BLOCKED',
  PERMANENT_RESERVED: 'IR',
  HOLD: 'H',
  PREDEFINED: 'PREDEFINED'
}

export const SEAT_GROUP_TYPES = {
  STANDING: 'STANDING'
}

export const OBJECT_TYPES = {
  SEAT: 'SEAT'
}

export const SEAT_TYPES = {
  CHAIR: 'chair',
  WHEELCHAIR: 'wheelchair'
}
